import { decrypt, gaEncrypt, getTransactionIdFromURL } from "../../constants/utils";
import * as authActions from "../actionTypes/authActionTypes"

export interface AuthState {
  authResponse: boolean;
  partnerId: string;
  partnerName: string;
  resumeJourneyEligibility: boolean;
  originalTxnId: string;
  ibError: any;
  customerId: string;
}

const initialState: AuthState = {
  authResponse: false,
  partnerId: "",
  partnerName: "",
  resumeJourneyEligibility: true,
  originalTxnId: "",
  ibError: false,
  customerId : "",
}

export const AuthReducer = (
  state: AuthState = initialState,
  action: authActions.AuthActions
): AuthState => {
  switch (action.type) {
    case authActions.GET_IB_AUTHENTICATION_SUCCESS:
      return {
        ...state,
        authResponse: action.authResponse,
        partnerId: action.partnerId,
        partnerName: action.partnerName,
        resumeJourneyEligibility: action.resumeJourneyEligibility,
        originalTxnId: action.originalTxnId,
        customerId: action.customerId,
      };
      case authActions.GET_IB_AUTHENTICATION_ERROR:
      return {
        ...state,
        ibError : true
      };
    default:
      return state
  }
}